import { root } from './venue';
import { details } from './details';

export const venue = {
  ...root,
  details,
};
